import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Row action icons in a fixed order: View, Edit, page-specific extras (projected), More.
 * Clicks never bubble to the row click handler.
 */
@Component({
  selector: 'app-row-actions',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pp-table__action-group" (click)="$event.stopPropagation()">
      <button *ngIf="view" type="button" class="pp-btn--icon" [title]="viewLabel" [attr.aria-label]="viewLabel"
        (click)="viewClick.emit($event)">
        <i class="pi pi-eye"></i>
      </button>
      <button *ngIf="edit" type="button" class="pp-btn--icon" [title]="editLabel" [attr.aria-label]="editLabel"
        [disabled]="editDisabled" (click)="editClick.emit($event)">
        <i class="pi pi-pencil"></i>
      </button>
      <ng-content></ng-content>
      <button *ngIf="more" type="button" class="pp-btn--icon" title="More actions" aria-label="More actions"
        aria-haspopup="true" [disabled]="moreDisabled"
        (mousedown)="moreDown.emit($event)" (click)="moreClick.emit($event)">
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </div>
  `,
  styles: [':host { display: inline-block; }'],
})
export class RowActionsComponent {
  @Input() view = true;
  @Input() edit = true;
  @Input() more = false;
  @Input() editDisabled = false;
  @Input() moreDisabled = false;
  @Input() viewLabel = 'View';
  @Input() editLabel = 'Edit';

  @Output() viewClick = new EventEmitter<MouseEvent>();
  @Output() editClick = new EventEmitter<MouseEvent>();
  /** Fires before `moreClick` so pages can set the selected row and rebuild their menu. */
  @Output() moreDown = new EventEmitter<MouseEvent>();
  @Output() moreClick = new EventEmitter<MouseEvent>();
}
